jQuery(window).on("load", function () {
    $('.team-block .slider-team, .slider-residences-photo').css('opacity', '1');

    [].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.onload = function () {
            img.removeAttribute('data-src');
        };
    });

    if ($('div').hasClass('gallery-block')) {
        $(window).scrollTop($(window).scrollTop() + 1);
    }

});

$(document).ready(function () {
    var _cookie = Cookies.get('cookieAgree');
    if (_cookie === undefined) {
        $('#cookie').css('display', 'block');
        $('#cookie button').click(function () {
            Cookies.set('cookieAgree', true, {expires: 365});
            $('#cookie').css('display', 'none');
        });
    }

    $("#menu").mmenu({
        "extensions": [
                "pagedim-black",
                "border-offset",
                "shadow-page"
             ]
    });

    var api = $('#menu').data('mmenu');
    api.bind("close:finish", function () {
        $('.ham').removeClass('active');
    });

    $("#menu").mhead();

    $('.social').removeClass('mm-listitem');
    $('.social a').removeClass('mm-listitem__text');

    /*$("nav .mm-listitem__text").click(
        function (evnt) {
            evnt.preventDefault();
            api.close();
        }
    )*/

    $('.residences-page .text').parents('.row').find('.img-wrap').height($('.residences-page .text').parent().height())

    $('.team-block form').validate({
        submitHandler: function (form) {
            $('.team-block form').ajaxSubmit({
                clearForm: true,
                success: function () {
                    $('.toast-body').css('color', '#28a745');
                    $('.toast-body').text($('.team-block form .toast-body').data('success'));
                    $('.team-block .toast').toast('show');
                    $('.team-block form').trigger('reset');
                },
                error: function () {
                    console.log($(this));
                    $('.toast-body').css('color', '#F03E30');
                    $('.toast-body').text($('.team-block form .toast-body').data('error'));
                    $('.team-block .toast').toast('show');
                }
            });
        }
    });

    $('.contact-block form').validate({
        submitHandler: function (form) {
            $('.contact-block form button').attr('disabled', 'true');
            $('.contact-block form').ajaxSubmit({
                clearForm: true,
                success: function () {
                    $('.toast-body').css('color', '#28a745');
                    $('.toast-body').text($('.contact-block form .toast-body').data('success'));
                    $('.contact-block .toast').toast('show');
                    $('.contact-block form').trigger('reset');
                    $('.contact-block form button').attr('disabled', 'false');
                },
                error: function () {
                    $('.toast-body').css('color', '#F03E30');
                    $('.toast-body').text($('.contact-block form .toast-body').data('error'));
                    $('.contact-block .toast').toast('show');
                    $('.contact-block form button').attr('disabled', 'false');
                }
            });
        }
    });

    $('.modal form').validate({
        submitHandler: function (form) {
            $('.modal form').ajaxSubmit({
                clearForm: true,
                success: function () {
                    $('.modal .modal-header, .modal .modal-body').slideUp();
                    $('.modal .result').css('color', '#28a745').text($('.modal form').data('success')).slideDown();
                    setTimeout(function () {
                        $('#pricemodal').modal('hide');
                    }, 8000);
                    $('.modal form').trigger('reset');
                },
                error: function () {
                    $('.modal .modal-header, .modal .modal-body').slideUp();
                    $('.modal .result').css('color', '#F03E30').text($('.modal form').data('error')).slideDown();
                    setTimeout(function () {
                        $('#pricemodal').modal('hide');
                    }, 8000);
                }
            });
        }
    });

    $('#pricemodal').on('hidden.bs.modal', function (e) {
        $('.modal-body input[name=url]').val('');
        $('.modal .result').hide();
        $('.modal .modal-header, .modal .modal-body').show();
    })

    $('.slider-team').slick({
        centerMode: true,
        centerPadding: '200px',
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    centerPadding: '170px'
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '140px'
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    centerPadding: '120px'
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '90px'
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    centerPadding: '0px'
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '0px'
                }
            }
          ]
    });

    $('.slider-residences-photo').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
          ]
    });

    $('.slider-residences-plan').slick({
        lazyLoad: 'ondemand',
        centerMode: true,
        centerPadding: '950px',
        slidesToShow: 1,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 2600,
                settings: {
                    centerPadding: '750px'
                }
            },
            {
                breakpoint: 2000,
                settings: {
                    centerPadding: '450px'
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '370px'
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    centerPadding: '270px'
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    centerPadding: '40px'
                }
            }
        ]
    });

    /*if ($(window).width() > 1200) {
        $('.slick-current').next().next().addClass('next-item');
        $('.slick-current').prev().prev().prev().addClass('prev-item');

        $('.slider-team').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-slide').removeClass('next-item prev-item')
            $('.slick-current').next().next().addClass('next-item');
            $('.slick-current').prev().prev().prev().addClass('prev-item');
        });
    } else {
        $('.slick-current').next().next().addClass('next-item');
        $('.slick-current').prev().prev().addClass('prev-item');

        $('.slider-team').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-slide').removeClass('next-item prev-item')
            $('.slick-current').next().next().addClass('next-item');
            $('.slick-current').prev().prev().addClass('prev-item');
        });
    }*/

    if ($(window).width() < 992) {
        var lastScrollTop = 0;
        $(window).scroll(function (event) {
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                $('.menu-link').addClass('mh-scrolledout');
            } else if (st == 0) {
                //$('.menu-link').addClass('mh-scrolledout');
            } else {
                $('.menu-link').removeClass('mh-scrolledout');
            }

            lastScrollTop = st;
        });
    }

    /*if ($(window).width() > 992) {
        var highestBox = 0;
        jQuery('.blog-block .item').each(function () {
            if (jQuery(this).height() > highestBox) {
                highestBox = jQuery(this).height();
            }
        });
        jQuery('.blog-block .item').height(highestBox);
    }*/

    var location = window.location.href;
    var cur_url = location.split('/').pop();

    $('header nav ul li').each(function () {
        var link = $(this).find('a').attr('href');

        if (cur_url == link) {
            $(this).find('a').addClass('current');
        }
    });

    $('.blog-page .wrap').masonry({
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
        transitionDuration: 0,
    });

    var tempTime = 700;
    $('[data-fancybox="images"]').fancybox({
        beforeShow: function (instance, current) {

            setTimeout(function () {
                var thisSLide = $($('.fancybox-infobar span')[0]).text();
                var allSLide = $($('.fancybox-infobar span')[1]).text();

                var title, descr, poster;
                $('.fancybox-slide--current .text').remove();

                for (i = 0; i < allSLide + 1; i++) {
                    if (thisSLide == i) {
                        title = $('.gallery-block .item').eq(i - 1).find('h3').text();
                        descr = $('.gallery-block .item').eq(i - 1).find('h3').data('descr');
                        poster = $('.gallery-block .item').eq(i - 1).find('.img').attr('data-poster');
                    }
                }

                console.log('heightText', title == '');
                if (title !== '') {
                    $('<div class="text"><div class="title"></div><div class="descr"></div></div>').prependTo('.fancybox-slide--current');
                } else {}

                if ($('.fancybox-slide--current .fancybox-content video').hasClass('fancybox-video')) {
                    $('<div class="play"></div>').prependTo('.fancybox-slide--current .fancybox-content');
                }
                var heightText = $('.fancybox-slide--current .fancybox-content').height();
                var widthText = $('.fancybox-slide--current .fancybox-content').width();
                $('.fancybox-slide--current .text').height(heightText);
                $('.fancybox-slide--current .text').width(widthText);
                $('.fancybox-slide--current .title').text(title);
                $('.fancybox-slide--current .descr').text(descr);
                $('.fancybox-slide--current .fancybox-video').attr('poster', poster);

                $('.fancybox-video').trigger('pause');
                //                $('.fancybox-slide--current .fancybox-video').trigger('play');
                if ($('.fancybox-slide--current .fancybox-content video').hasClass('fancybox-video')) {
                    tempTime = 700;
                }
            }, tempTime)
            if ($('.fancybox-slide--current .fancybox-content video').hasClass('fancybox-video')) {
                tempTime = 700;
            } else {
                tempTime = 50;
            }

        },
        //        afterLoad: function (instance, current) {
        //            console.log('122');
        //
        //            var title, descr;
        //            $('.fancybox-slide--current .text').remove();
        //            var thisSLide = $($('.fancybox-infobar span')[0]).text();
        //            var allSLide = $($('.fancybox-infobar span')[1]).text();
        //
        //            console.log(thisSLide);
        //            for (i = 0; i < allSLide + 1; i++) {
        //                if (thisSLide == i) {
        //                    title = $('.gallery-block .item').eq(i - 1).find('h3').text();
        //                    descr = $('.gallery-block .item').eq(i - 1).find('h3').data('descr');
        //                }
        //            }
        //
        //            $('<div class="text"><div class="title"></div><div class="descr"></div></div>').prependTo('.fancybox-slide--current');
        //            var heightText = $('.fancybox-slide--current .fancybox-content').height();
        //            $('.fancybox-slide--current .text').height(heightText);
        //            $('.fancybox-slide--current .title').text(title);
        //            $('.fancybox-slide--current .descr').text(descr);
        //
        //        }
    });

    $('body').on('click', '.play', function () {
        $(this).hide();
        $('.fancybox-slide--current .fancybox-video').trigger('play');
    })

    $('body').on('click', 'video', function () {
        $('body .play').hide();
    })

    $('a[href*="#"]').on("click", function (event) {
        event.preventDefault();
        var anchor = $(this).attr('href');
        $('body,html').animate({
            scrollTop: $(anchor).offset().top
        }, 800);
    });

    (function () {

        nLazy = function () {
            $('div[data-background]:visible').each(function () {
                var $this = $(this)
                var src = $this.data('background')
                var imageTop = $this.offset().top
                var windowSize = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
                var windowBottom = $(document).scrollTop() + windowSize
                if (imageTop <= windowBottom) {
                    $this.addClass('nl-loading')
                    $img = $('<img>').attr('src', src).on('load', function () {
                        $(this).remove()
                        $this
                            .css({
                                'opacity': 0,
                                'background-image': 'url(' + src + ')'
                            })
                            .removeClass('nl-loading')
                            .addClass('nl-loaded')
                            .animate({
                                'opacity': 1
                            }, 'fast')
                            .removeAttr('data-background')
                    })
                }
            })
        }

        $(window).scroll(nLazy)

    })()

    var heightSecondMenu;
    for (i = 0; i < $('.submenu').length; i++) {
        var heightSecondMenu = $('.submenu').eq(i).height()
        if (heightSecondMenu < 25) {
            $('.submenu').eq(i).find('.sub-menu').css('top', '18px');
        } else {
            $('.submenu').eq(i).find('.sub-menu').css('top', '35px');
        }
    }

    $('.get-price').click(function () {
        var urlObject = $(this).find('button').data('url');
        var nameObject = $(this).find('button').data('name');
        $('.modal-body input[name=url]').val(urlObject);
        $('.modal-body input[name=obj_name]').val(nameObject);
    });

    $('.viewing').click(function () {
        var urlObject = $(this).data('url');
        var nameObject = $(this).data('name');
        $('#feedback input[name=subject]').val('Sign up for viewing');
        $('#feedback input[name=url]').val(urlObject);
        $('#feedback input[name=obj_name]').val(nameObject);
    });

    $('.obj-contact, .investor').click(function () {
        var urlObject = $(this).data('url');
        var nameObject = $(this).data('name');
        var subObject = $(this).data('subject');
        $('#feedback input[name=subject]').val(subObject);
        $('#feedback input[name=url]').val(urlObject);
        $('#feedback input[name=obj_name]').val(nameObject);
    });
});